import type { UseDuplicateProps } from "./useDuplicate.type";
import type { ApiError, ApiPayloadDuplicate } from "@/services/api";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { client } from "@/config/client";
import { getModelApiKey } from "@/modules/model";

export const useDuplicate = <Data = unknown, Variables = unknown>({
  modelKey,
  id,
  onSuccess,
  invalidateKeys,
  ...options
}: UseDuplicateProps<Data, Variables>) => {
  const queryClient = useQueryClient();

  const mutationFn = (variables: Variables) => {
    const model = getModelApiKey(modelKey);
    return client[model].duplicate(id, variables);
  };

  const onMutationSuccess = (payload: ApiPayloadDuplicate<Data>) => {
    onSuccess?.(payload.data.data);

    invalidateKeys?.forEach((queryKey) =>
      queryClient.invalidateQueries({ queryKey })
    );
  };

  return useMutation<ApiPayloadDuplicate<Data>, ApiError, Variables>({
    mutationFn,
    onSuccess: onMutationSuccess,
    ...options,
  });
};
